import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { useNavigateQuestion } from "service/stores/Question/Statics";
import { htmlToPlain } from "utils/common";
import { EndExerciseQuestion } from "service/question";

interface ListItemProps {
    index: number;
    data: EndExerciseQuestion;
    selected?: boolean;
}

export default function ListItem({ index, data, selected }: ListItemProps) {
    const { go } = useNavigateQuestion();

    function onClick() {
        window.scrollTo(0, 0);
        go(data.id);
    }

    return (
        <div
            className={classNames(style.root, selected ? style.selected : "")}
            onClick={onClick}>
            {index + 1}.
            <span className={style.info}>（{data.queTypeName}）</span>
            {htmlToPlain(data.contentText)}
        </div>
    );
}
